
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { ICategory } from '@/types';
import { getCategories } from 'api/articles';
import { Breadcrumbs } from 'components/common/Breadcrumbs';
import { ArticlesSection } from 'components/editorial/articles/ArticlesSection';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import qs from 'qs';
import { ReactElement } from 'react';
interface Props {
    category: ICategory;
    url: string;
    categorySlug: string;
}
const Article = ({ url, category, categorySlug }: Props) => {
    return (<div>
      <Head>
        <title>{category.attributes.name}</title>

        <meta name='description' content={category.attributes?.description}/>

        <meta name='og:title' content={category.attributes.name}/>
        <meta name='og:description' content={category.attributes?.description}/>

        <link rel='canonical' href={`${process.env.NEXT_PUBLIC_SITE_URL}${url}`}/>
      </Head>

      <div className='flex flex-col pb-16'>
        <Breadcrumbs url={url} className='container'/>

        <ArticlesSection categorySlug={categorySlug}/>
      </div>
    </div>);
};
Article.getLayout = (page: ReactElement) => (<BaseLayout style='pure-white'>{page}</BaseLayout>);
const fetchCategory = async (categorySlug: string) => {
    const query = qs.stringify({
        populate: ['cover', 'cover.image'],
        filters: {
            name: { $eqi: categorySlug.replaceAll('-', ' ') }
        }
    }, {
        encodeValuesOnly: true
    });
    const categories = await getCategories(query);
    if (!categories.data[0]) {
        return null;
    }
    return categories.data[0];
};
const getServerSideProps: GetServerSideProps<Props> = async ({ params, res, }) => {
    res.setHeader('Cache-Control', `public, s-maxage=${12 * 60 * 60}, stale-while-revalidate=${60 * 60}`);
    const categorySlug = params?.slug as string;
    if (!categorySlug) {
        return { notFound: true, props: { error: 'NO CATEGORY' } };
    }
    const category = await fetchCategory(categorySlug);
    if (!category) {
        return { notFound: true, props: { error: 'NO CATEGORY' } };
    }
    try {
        return {
            props: {
                category,
                url: `/editorial/${categorySlug}`,
                categorySlug
            }
        };
    }
    catch (err) {
        console.log(err);
        return { notFound: true, props: { error: (err as Error).message, err } };
    }
};
export default Article;

    async function __Next_Translate__getServerSideProps__197f51ae406__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/editorial/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__197f51ae406__ as getServerSideProps }
  